module.exports = __webpack_public_path__ + "zvetseni-prsou_8_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_8_before.jpg
// module id = 1370
// module chunks = 0